// extracted by mini-css-extract-plugin
export default {"title_section_of_page":"TitleSection_title_section_of_page__4cjK-","title_text":"TitleSection_title_text__ECWyD"};